import { ReactNode, useState } from 'react'
import CollectionBadge from './CollectionBadge'
import Sidebar from './Sidebar'
import GlobalSearch from './GlobalSearch'
import { Sym } from '../ui/Sym'
import ThemeToggle from '../ui/ThemeToggle'

interface AppShellProps {
  children: ReactNode
}

export default function AppShell({ children }: AppShellProps) {
  const [mobileNavOpen, setMobileNavOpen] = useState(false)

  return (
    <div className="flex h-screen bg-background text-text-primary overflow-hidden">
      <Sidebar mobileOpen={mobileNavOpen} onClose={() => setMobileNavOpen(false)} />

      {/* Backdrop for the mobile drawer */}
      {mobileNavOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/50 lg:hidden"
          aria-hidden="true"
          onClick={() => setMobileNavOpen(false)}
        />
      )}

      <main className="flex flex-col flex-1 min-w-0">
        {/* Topbar */}
        <header className="h-[60px] border-b border-border-soft flex items-center gap-2 sm:gap-4 px-4 sm:px-6 flex-shrink-0">
          <button
            className="lg:hidden text-text-muted hover:text-text-primary flex-shrink-0"
            aria-label="Open navigation"
            onClick={() => setMobileNavOpen(true)}
          >
            <Sym name="menu" size={22} />
          </button>
          <div className="flex-1 flex items-center min-w-0">
            <GlobalSearch />
          </div>
          {/* Was two lines of static markup - a bg-success dot and the words "All systems
              collecting" - with no props, no query and no state. It said that for four
              straight days while the nightly scan did not run. See CollectionBadge. */}
          <CollectionBadge />
          <ThemeToggle />
          <button className="text-text-muted hover:text-text-primary flex-shrink-0" aria-label="Notifications">
            <Sym name="notifications" size={20} />
          </button>
        </header>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-4 sm:p-6">{children}</div>
      </main>
    </div>
  )
}
